import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

// export const exportToExcel = (
//   data,
//   fileName = 'export',
//   sheetName = 'Sheet1',
//   title = 'My Exported Data'
// ) => {
//   if (!data || data.length === 0) {
//     console.warn("No data provided for Excel export.");
//     return;
//   }
//   // Determine how many columns the data has
//   const numColumns = Object.keys(data[0]).length;
//   const lastColLetter = XLSX.utils.encode_col(numColumns - 1); // e.g., 'F' for 6 columns
//   const worksheet = XLSX.utils.aoa_to_sheet([[title]]);
//   worksheet['!merges'] = [
//     {
//       s: { r: 0, c: 0 }, // start: A1
//       e: { r: 0, c: numColumns - 1 }, // end: e.g., F1
//     },
//   ];
//   // Optionally style title (bold, centered)
//   const titleCell = worksheet['A1'];
//   if (titleCell) {
//     titleCell.s = {
//       font: { bold: true, sz: 14 },
//       alignment: { horizontal: 'center' },
//     };
//   }
//   XLSX.utils.sheet_add_json(worksheet, data, {
//     origin: 'A2',
//     skipHeader: false,
//   });
//   // Create workbook and add worksheet
//   const workbook = XLSX.utils.book_new();
//   XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);

// worksheet['!cols'] = Object.keys(data[0]).map((key) => {
//   const maxLength = Math.max(
//     key.length,
//     ...data.map((row) => String(row[key] ?? '').length)
//   );
//   return { wch: maxLength + 2 }; // Adjust padding if needed
// });

//   // Write and download
//   const excelBuffer = XLSX.write(workbook, {
//     bookType: 'xlsx',
//     type: 'array',
//     cellStyles: true, // optional
//   });
//   const fileData = new Blob([excelBuffer], {
//     type: 'application/octet-stream',
//   });
//   saveAs(fileData, `${fileName}.xlsx`);
// };
// export const exportToExcel = (
//   data,
//   fileName = 'export',
//   sheetName = 'Sheet1',
//   title = 'My Exported Data',
//   startDate = '01-01-2025',
//   endDate = '10-01-2025'
// ) => {
//   if (!data || data.length === 0) {
//     console.warn("No data provided for Excel export.");
//     return;
//   }

//   const numColumns = Object.keys(data[0]).length;
//   const worksheet = XLSX.utils.aoa_to_sheet([
//     ['', `Start Date: ${startDate}`, `End Date: ${endDate}`], // Row 1: starts at B1
//     [title] // Row 2: title
//   ]);

//   // Merge title row across all columns
//   worksheet['!merges'] = [
//     {
//       s: { r: 0, c: 0 }, // A1
//       e: { r: 0, c: numColumns - 1 } // e.g., F1
//     }
//   ];

//   // Style the title cell (A1)
//   const titleCell = worksheet['B1'];
//   if (titleCell) {
//     titleCell.s = {
//       font: { bold: true, sz: 14 },
//       alignment: { horizontal: 'center' }
//     };
//   }

//   // Add JSON data starting from A3 (after title and filters)
//   XLSX.utils.sheet_add_json(worksheet, data, {
//     origin: 'A3',
//     skipHeader: false,
//   });

//   // Auto column width
//   worksheet['!cols'] = Object.keys(data[0]).map((key) => {
//     const maxLength = Math.max(
//       key.length,
//       ...data.map((row) => String(row[key] ?? '').length)
//     );
//     return { wch: maxLength + 2 };
//   });

//   const workbook = XLSX.utils.book_new();
//   XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);

//   const excelBuffer = XLSX.write(workbook, {
//     bookType: 'xlsx',
//     type: 'array',
//     cellStyles: true,
//   });

//   const fileData = new Blob([excelBuffer], {
//     type: 'application/octet-stream',
//   });

//   saveAs(fileData, `${fileName}.xlsx`);
// };
// export const exportToExcel = (
//   data,
//   fileName = 'export',
//   sheetName = 'Sheet1',
//   title = 'My Exported Data',
//   startDate = '01-01-2025',
//   endDate = '10-01-2025'
// ) => {
//   if (!data || data.length === 0) {
//     console.warn("No data provided for Excel export.");
//     return;
//   }

//   const numColumns = Object.keys(data[0]).length;
//   const worksheet = XLSX.utils.aoa_to_sheet([
//     ['', `Start Date: ${startDate}`, `End Date: ${endDate}`], // Row 1: starts at B1
//     [title] // Row 2: title
//   ]);

//   // Merge title across columns in Row 2 (A2 to last column)
//   worksheet['!merges'] = [
//     {
//       s: { r: 1, c: 0 }, // A2
//       e: { r: 1, c: numColumns - 1 } // e.g., F2
//     }
//   ];

//   // Style the title cell (A2)
//   const titleCell = worksheet['A2'];
//   if (titleCell) {
//     titleCell.s = {
//       font: { bold: true, sz: 14 },
//       alignment: { horizontal: 'center' }
//     };
//   }

//   // Add table data starting from A3 (third row)
//   XLSX.utils.sheet_add_json(worksheet, data, {
//     origin: 'A3',
//     skipHeader: false,
//   });

//   // Auto column widths
//   worksheet['!cols'] = Object.keys(data[0]).map((key) => {
//     const maxLength = Math.max(
//       key.length,
//       ...data.map((row) => String(row[key] ?? '').length)
//     );
//     return { wch: maxLength + 2 };
//   });

//   const workbook = XLSX.utils.book_new();
//   XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);

//   const excelBuffer = XLSX.write(workbook, {
//     bookType: 'xlsx',
//     type: 'array',
//     cellStyles: true,
//   });

//   const fileData = new Blob([excelBuffer], {
//     type: 'application/octet-stream',
//   });

//   saveAs(fileData, `${fileName}.xlsx`);
// };
export const exportToExcel = (
  data,
  fileName = 'export',
  sheetName = 'Sheet1',
  title = 'My Exported Data',
  startDate = startDate,
  endDate = endDate
) => {
  if (!data || data.length === 0) {
    console.warn("No data provided for Excel export.");
    return;
  }

  const numColumns = Object.keys(data[0]).length;

    // Step 1: Create the initial worksheet array (rows)
  const worksheetRows = [
    [title], // Row 1: Title
  ];

  // Add startDate and endDate row only if either is provided
  if (startDate || endDate) {
    const filterRow = ['']; // Start from column B
    if (startDate) filterRow.push(`Start Date: ${startDate}`);
    if (endDate) filterRow.push(`End Date: ${endDate}`);
    worksheetRows.push(filterRow);
  }

   const worksheet = XLSX.utils.aoa_to_sheet(worksheetRows);
  // // Step 1: Create worksheet with title in row 1 and filters in row 2 (starting from B2)
  // const worksheet = XLSX.utils.aoa_to_sheet([
  //   [title], // Row 1: Title
  // ]);

  // Step 2: Merge title across all columns in row 1 (A1 to last column)
  worksheet['!merges'] = [
    {
      s: { r: 0, c: 0 }, // A1
      e: { r: 0, c: numColumns - 1 } // e.g., F1
    }
  ];

  // Step 3: Style title cell (A1)
  const titleCell = worksheet['A1'];
  if (titleCell) {
    titleCell.s = {
      font: { bold: true, sz: 14 },
      alignment: { horizontal: 'center' }
    };
  }

  // Step 4: Add JSON data starting from row 3 (A3)
  XLSX.utils.sheet_add_json(worksheet, data, {
    origin: 'A3',
    skipHeader: false,
  });

  // Step 5: Auto column widths
  worksheet['!cols'] = Object.keys(data[0]).map((key) => {
    const maxLength = Math.max(
      key.length,
      ...data.map((row) => String(row[key] ?? '').length)
    );
    return { wch: maxLength + 2 };
  });

  // Step 6: Generate and download the Excel file
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);

  const excelBuffer = XLSX.write(workbook, {
    bookType: 'xlsx',
    type: 'array',
    cellStyles: true,
  });

  const fileData = new Blob([excelBuffer], {
    type: 'application/octet-stream',
  });

  saveAs(fileData, `${fileName}.xlsx`);
};

